import { defineComponent, computed } from 'vue';
import __vue_component__ from '../../../../../components/buttons/ButtonComponent/ButtonComponent.vue.js';
import 'immutability-helper';
import { getRouter } from '../../../../../router/helpers/initRouter.js';
import '../../../../../router/routes/dev/model.js';
import '../../../../../router/routes/dev/routes.js';
import { draftWaypointDetailsRoute } from '../../../../../router/routes/locations.js';
import '@caresend/types';
import '../../../../../router/routes/orderFlow/model.js';
import '../../../../../router/routes/orderFlow/privateHelpers.js';
import '../../../../../router/routes/orderFlow/routes.js';
import '../../../../../router/routes/schedulingFlow/model.js';
import '../../../../../router/routes/schedulingFlow/routes.js';
import '../../../../../router/routes/chartingFlow/model.js';
import '../../../../../router/routes/chartingFlow/routes.js';
import '../../../../../router/routes/portal/portalRoutes.js';
import '../../../../../router/routes/portal/model.js';
import '../../../../../router/routes/pro/model.js';
import '../../../../../router/routes/visitsPage/model.js';
import '../../../../../router/routes/visitsPage/routes.js';

var script = defineComponent({
    /** Only to be used for the rescheduling flow */
    name: 'DiscardChangesButton',
    components: { ButtonComponent: __vue_component__ },
    props: {
        oldDraftWaypointID: {
            type: String,
            required: true,
        },
    },
    setup(props) {
        const router = getRouter();
        const oldVisitLocation = computed(() => draftWaypointDetailsRoute({
            params: {
                draftWaypointID: props.oldDraftWaypointID,
            },
        }));
        const onClick = () => {
            if (!oldVisitLocation.value)
                throw new Error('No old visit location found');
            router.push(oldVisitLocation.value);
        };
        return {
            oldVisitLocation,
            onClick,
        };
    },
});

export { script as default };
